import React from 'react';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import {
  Field2 as Field,
  DaySelector,
} from 'vibeguide';

const hourOptions = [];
for (let i = 0; i <= 24; i++) {
  const hour = i < 10 ? `0${i}:00` : `${i}:00`;
  hourOptions.push({
    label: hour,
    value: hour,
  });
}

function SegmentDateTime({
  startDate,
  endDate,
  daysOfWeek,
  onUpdate,
}) {
  const onChangeStartDate = (startDate) => {
    onUpdate({
      startDate,
    });
  };

  const onChangeEndDate = (endDate) => {
    onUpdate({
      endDate,
    });
  };

  const onChangeDays = (days) => {
    onUpdate({
      daysOfWeek: days,
    });
  };

  return (
    <div
      className="SegmentDateTime"
    >
      <Grid
        spacing={2}
        container
      >
        <Grid
          xs={6}
          item
        >
          <Field
            type="datepicker"
            label="Start Date"
            placeholder="YYYY-MM-DD"
            value={startDate}
            dateProps={{
              format: 'YYYY-MM-DD',
            }}
            tabIndex={36}
            onChange={onChangeStartDate}
            required
          />
        </Grid>
        <Grid
          xs={6}
          item
        >
          <Field
            type="datepicker"
            label="End Date"
            placeholder="YYYY-MM-DD"
            value={endDate}
            dateProps={{
              format: 'YYYY-MM-DD',
            }}
            tabIndex={37}
            onChange={onChangeEndDate}
            required
          />
        </Grid>
        <Grid
          xs={12}
          item
        >
          <Field
            type="custom"
            label="Days"
            tabIndex={38}
            required
          >
            <DaySelector
              style={{
                width: 250,
              }}
              dayFormat="dd"
              selectedDays={daysOfWeek}
              toggleAll
              onChange={onChangeDays}
            />
          </Field>
        </Grid>
      </Grid>
    </div>
  );
}

SegmentDateTime.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  daysOfWeek: PropTypes.arrayOf(PropTypes.string),
  onUpdate: PropTypes.func,
};

SegmentDateTime.defaultProps = {
  startDate: '',
  endDate: '',
  daysOfWeek: [],
  onUpdate: () => {},
};

export default SegmentDateTime;
